import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { Button, Menu, Stack } from "@mui/material";
import { useCallback, type FC } from "react";
import { usePopover } from "../../../../../../utils/hooks/use-popover";
import {
  INSERT_DATA_TABLE_COLUMN_COMMAND,
  INSERT_DATA_TABLE_ROW_COMMAND,
} from "../../../types/commands";
import { InsertColumnButtons } from "../../table-menu/buttons/insert-column-buttons";
import { ToolbarIconButton } from "../toolbar-icon-button";

export const DataTableMenuInsert: FC = () => {
  const { anchorRef, handleToggle, handleClose, open } = usePopover<HTMLButtonElement>();
  const [editor] = useLexicalComposerContext();

  const handleInsertColumn = useCallback(
    (insertAfter: boolean) => {
      editor.dispatchCommand(INSERT_DATA_TABLE_COLUMN_COMMAND, { insertAfter });
    },
    [editor],
  );

  const handleInsertRow = useCallback(
    (position: "top" | "bottom") => {
      editor.dispatchCommand(INSERT_DATA_TABLE_ROW_COMMAND, { position });
    },
    [editor],
  );

  return (
    <>
      <Button
        ref={anchorRef}
        data-analytics-id="lexical-table-menu-insert"
        onClick={handleToggle}
        endIcon={
          <KeyboardArrowDown
            sx={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
            }}
          />
        }
        sx={{ whiteSpace: "nowrap", color: "text.secondary" }}
        size="small"
      >
        Insert
      </Button>
      <Menu
        // eslint-disable-next-line react-hooks/refs
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Stack>
          <ToolbarIconButton
            data-analytics-id="lexical-table-menu-insert-row-top"
            disabled={!editor._editable}
            label="Insert row top"
            icon={<KeyboardArrowUp fontSize="small" />}
            data-testid="table-menu-insert-row-top"
            aria-label="insert-row-top"
            onClick={() => handleInsertRow("top")}
          />
          <ToolbarIconButton
            data-analytics-id="lexical-table-menu-insert-row-bottom"
            disabled={!editor._editable}
            label="Insert row bottom"
            icon={<KeyboardArrowDown fontSize="small" />}
            data-testid="table-menu-insert-row-bottom"
            aria-label="insert-row-bottom"
            onClick={() => handleInsertRow("bottom")}
          />
          <InsertColumnButtons handleInsertColumn={handleInsertColumn} />
        </Stack>
      </Menu>
    </>
  );
};
